<template>
  <!-- 抽成歷史報表 -->
  <section class="content">
    <div class="row center-block">
      <div class="col-xs-12 p-x-0 m-b-10">
        <button @click="$router.go(-1)" class="btn btn-default">
          返回抽成列表
        </button>
      </div>
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h5>
              <span class="text-red">＊</span>
              每月4號 00:00 產出前一個月份報表
            </h5>
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                    <tr role="row">
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">#</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">月份</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">連結 (ID)</th>
                    </tr>
                  </thead>
                  <tbody v-if="isLoading">
                    <tr>
                      <td colspan="3" class="text-center">資料讀取中......</td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="list.length === 0" >
                    <tr style="background-color: white">
                      <td rowspan="1" colspan="3" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                        <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                        <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr v-for="(row, index) in list" :key="index" class="even" role="row">
                      <td class="sorting_1">
                        {{ index + 1 }}
                      </td>
                      <td v-if="row.unit_value">
                        {{ row.year }}-{{ row.unit_type === 1 ? row.unit_value.toString().padStart(2, '0') : 'Q' + row.unit_value }}
                        {{ row.unit_type === 2 ? `(${ quarterList[row.unit_value - 1] })` : '' }}
                      </td>
                      <td>
                        <a :href="row.url">點擊下載</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <paginate
                :pageAmount="pageAmount"
                :total="total"
                :isActive="isActive"
                :groupAmount="groupAmount"
                :clickPage="clickPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <button v-show="false" ref="refreshModal" class="btn btn-danger pull-right m-y-10 " data-toggle="modal" data-target="#refreshModal"></button>
    <m-modal class="text-left" :option="refreshOption" @trigger="trigger"></m-modal>
  </section>
</template>

<script>
import matcherModal from '../../elements/Modal.vue'

export default {
  name: 'CommissionHistory',
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      total: 0,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      isLoading: false,
      list: [],
      quarterList: ['1-3月', '4-6月', '7-9月', '10-12月'],
      aclLimit: 0, // 下載的過期秒數
      timer: null,
      refreshOption: {
        id: 'refreshModal',
        title: '下載連結已過期，點擊"確定"按鈕更新列表',
        body: '',
        btns: [
          {
            name: '確定',
            event: 'refresh'
          }
        ]
      }
    }
  },
  computed: {
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    getDataH () {
      return this.$parent.getDataH
    }
  },
  created () {
    this.getList()
  },
  methods: {
    clickPage (index) {
      this.tableIndex = index
      this.getList()
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    trigger (event) {
      if (event === 'refresh') {
        this.getList()
      }
    },
    getList () {
      this.isLoading = true
      if (this.timer) {
        clearInterval(this.timer)
      }
      let type = ''
      let query = ''
      if (this.$route.query.store_id) {
        type = 'store'
        query = '&store_id=' + this.$route.query.store_id
      } else {
        type = 'brand'
        query = '&brand_id=' + this.$route.query.brand_id
      }
      let url = 'orderCommission/' + type + 'Statement?page=' + this.tableIndex + '&size=' + this.count + query
      this.getDataH('get', url, null, (response) => {
        this.list = response.data.download_info.links
        this.aclLimit = response.data.download_info.meta.acl_limit
        this.total = response.data.total
        this.isLoading = false

        // 超過連結效用時間則更新列表
        if (this.list.length) {
          let time = this.aclLimit
          this.timer = setInterval(() => {
            time = time - 1
            if (time < 0) {
              this.$refs.refreshModal.click()
              clearInterval(this.timer)
            }
          }, 1000)
        }
      })
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CommissionHistory.vue?672d9abc